"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import Link from "next/link";
import Image from "next/image";
import { Dialog, Disclosure } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { mainMenu } from "@lib/menus";
import LogoWeb from "@public/images/logo web.svg";
export default function HeaderDrawer() {
  const $ = _c(7);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex lg:hidden"><button type="button" className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700" onClick={() => setMobileMenuOpen(true)}><span className="sr-only">Open main menu</span><Bars3Icon className="h-6 w-6" aria-hidden="true" /></button></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="fixed inset-0 z-10" />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Link href="/" className="-m-1.5 p-1.5"><span className="sr-only">GameAnglo Studios</span><Image className="h-12 w-auto" src={LogoWeb} alt="GameAnglo Studios" /></Link>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex items-center justify-between">{t2}<button type="button" className="-m-2.5 rounded-md p-2.5 text-gray-700" onClick={() => setMobileMenuOpen(false)}><span className="sr-only">Close menu</span><XMarkIcon className="h-6 w-6" aria-hidden="true" /></button></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Dialog.Panel className="fixed inset-y-0 left-0 z-10 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">{t3}<div className="mt-6 flow-root"><div className="-my-6 divide-y divide-gray-500/10"><div className="space-y-2 py-6">{mainMenu.map(_temp2)}</div></div></div></Dialog.Panel>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== mobileMenuOpen) {
    t5 = <>{t0}<Dialog as="div" className="lg:hidden" open={mobileMenuOpen} onClose={setMobileMenuOpen}>{t1}{t4}</Dialog></>;
    $[5] = mobileMenuOpen;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}
function _temp2(item) {
  if (!item.submenu) {
    return <Link key={item.name} href={item.href} className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50">{item.name}</Link>;
  } else {
    return <Disclosure key={item.name} as="div" className="-mx-3">{t0 => {
        const {
          open
        } = t0;
        return <><Disclosure.Button className="flex w-full items-center justify-between rounded-lg py-2 pl-3 pr-3.5 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50">{item.name}<ChevronDownIcon className={classNames(open ? "rotate-180" : "", "h-5 w-5 flex-none")} aria-hidden="true" /></Disclosure.Button><Disclosure.Panel className="mt-2 space-y-2">{[...(item.submenu || []), ...(item.cta || [])].map(_temp)}</Disclosure.Panel></>;
      }}</Disclosure>;
  }
}
function _temp(item_0) {
  return <Disclosure.Button key={item_0.name} as="a" href={item_0.href} className="block rounded-lg py-2 pl-6 pr-3 text-sm font-semibold leading-7 text-gray-900 hover:bg-gray-50">{item_0.name}</Disclosure.Button>;
}
function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(" ");
}